
import { styled } from '@mui/material/styles';
import { AppBar, Box, IconButton, Stack, Toolbar, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import AccountPopover from './AccountPopover';
import LanguagePopover from '../../../components/LanguagePopover';
import { APP_BAR_COLOR } from '../../../constants/colors';
import NotificationsPopover from './NotificationsPopover';


// ----------------------------------------------------------------------

interface Props {
    onOpenNav: VoidFunction,
    openNavDesktopScreen: boolean,
    isLgScreen: boolean,
    onOpenNavDesktopScreen: VoidFunction
}

const NAV_WIDTH = 280;

const HEADER_MOBILE = 64;

const HEADER_DESKTOP = 92;



const StyledToolbar = styled(Toolbar)(({ theme }) => ({
    minHeight: HEADER_MOBILE,
    [theme.breakpoints.up('lg')]: {
        minHeight: HEADER_DESKTOP,
        padding: theme.spacing(0, 5),
    },
}));

const Header = ({ onOpenNav, openNavDesktopScreen, isLgScreen, onOpenNavDesktopScreen }: Props) => {

    const StyledRoot = styled(AppBar)(({ theme }) => ({
        boxShadow: 'none',
        // backgroundColor:'transparent',
        backgroundColor: APP_BAR_COLOR,
        [theme.breakpoints.up('lg')]: {
            width: openNavDesktopScreen ? `calc(100% - ${NAV_WIDTH + 1}px)` : "100%",
        },
    }));

    return <StyledRoot>
        <StyledToolbar>
            <IconButton
                onClick={() => {
                    if (isLgScreen) {
                        onOpenNavDesktopScreen();
                    }
                    else {
                        onOpenNav();
                    }
                }}
                sx={{
                    mr: 1,
                    color: 'text.primary',
                    display: !isLgScreen ? { lg: 'none' } : !openNavDesktopScreen ? 'block' : "none",
                }}
            >
                <MenuIcon sx={{ color: 'black' }} />
            </IconButton>
            <Box sx={{ display: 'flex', gap: 1 }}>
                <Typography color="black">{process.env.REACT_APP_VERSION}</Typography>
                <Typography color="black">({process.env.REACT_APP_ENVIRONMENT})</Typography>
            </Box>
            <Box sx={{ flexGrow: 1 }} />
            <Stack
                direction="row"
                alignItems="center"
                spacing={{
                    xs: 0.5,
                    sm: 1,
                }}
            >
                <LanguagePopover />
                {/* <LanguagePopover /> */}
                {/* <NotificationsPopover />
                <AccountPopover /> */}
                {/* <NotificationsPopover /> */}
                <NotificationsPopover />
                <AccountPopover />

            </Stack>
        </StyledToolbar>
    </StyledRoot>
}
export default Header;